var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "./Content", "./MultiScreen"], function (require, exports, Content_1, MultiScreen_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Sujet = (function (_super) {
        __extends(Sujet, _super);
        function Sujet() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.Type = Content_1.ContentTypes.Sujet;
            return _this;
        }
        Object.defineProperty(Sujet.prototype, "IsMultiScreen", {
            get: function () { return false; },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Sujet.prototype, "IsSujet", {
            get: function () { return true; },
            enumerable: true,
            configurable: true
        });
        return Sujet;
    }(MultiScreen_1.MultiScreen));
    exports.Sujet = Sujet;
});
//# sourceMappingURL=Sujet.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Content/Sujet.js
// module id = 401
// module chunks = 0